/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiWebSlownikiKodGet$Json$Params {
  kod: string;
}

export function apiWebSlownikiKodGet$Json(http: HttpClient, rootUrl: string, params: ApiWebSlownikiKodGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<{
}>> {
  const rb = new RequestBuilder(rootUrl, apiWebSlownikiKodGet$Json.PATH, 'get');
  if (params) {
    rb.path('kod', params.kod, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      }>;
    })
  );
}

apiWebSlownikiKodGet$Json.PATH = '/api/web/slowniki/{kod}';
